import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer-content">
        <p className="footer-copy">© Copyright {new Date().getFullYear()} </p>
      </div>
    </>
  );
};
export default Footer;
